(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    const openShopPayPlans = (panel) => {
    const paymentTerms = panel.querySelector('shopify-payment-terms');
    const plansButton = paymentTerms?.shadowRoot?.querySelector('button[aria-label="View sample plans"]');
    plansButton?.click();
  };

  document.addEventListener('click', (event) => {
    const panel = event.target.closest?.('.shop-pay-highlight');
    if (!panel) return;

    const clickedControl = event.composedPath().some((element) => {
      return element instanceof Element && element.matches('button, a');
    });

    if (clickedControl) return;
    openShopPayPlans(panel);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const panel = event.target.closest?.('.shop-pay-highlight');
    if (!panel || event.target !== panel) return;

    event.preventDefault();
    openShopPayPlans(panel);
  });
  } catch(e) { console.error(e); }
})();

})();
